import useScrollReveal from "@/hooks/useScrollReveal";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import Gallery from "@/components/landing/Gallery";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import Contact from "@/components/landing/Contact";

export default function Landing() {
  useScrollReveal();

  return (
    <div className="bg-[#F4F1EA] text-[#1A2B3C]">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Gallery />
        <Testimonials />
        <FAQ />
      </main>
      <Contact />
    </div>
  );
}
